<template>
  <div class="fill-height"
    :style="[
      {'background-color': `#F4F4F4`} 
    ]"
  >
    <strategio-app-bar></strategio-app-bar>
    <v-main style="height:100vh; padding-top:87px">
      <div style="max-height:100%; overflow:auto">
        <v-container>
          <v-row class="strategio-titles-windows" >
            <v-col cols="12" class="d-flex">
              <v-icon color="black" style="font-size:52px; margin-right: 5px;"
                @click="goBack"
                >arrow_back</v-icon>
              <span style="font-size:45px; font-weight:bold;color:black; -webkit-text-stroke: 2px black;">
                Datos cargados
              </span>
            </v-col>
          </v-row>
          <v-row class="mx-5">
            <v-col cols="9">
              <div v-for="(item, index) in dataInfo" :key="index">
                <p><b>{{item.validationName}}:</b> {{formatNum(item.value)}}</p>
              </div>
            </v-col>
            <v-col cols="3" class="d-flex justify-end">
              <v-btn color="success" @click="donwnloadData" :loading="btnDownload.isLoad" :disabled="btnDownload.isLoad">
                Descargar
                <v-icon
                  dark
                  right
                >
                  mdi-cloud-download
                </v-icon>
                <template v-slot:loader>
                  <span>Cargando</span>
                  <v-progress-circular
                    indeterminate
                    size="16"
                    color="white"
                    class="ml-1"
                  ></v-progress-circular>
                </template>
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="mx-5 justify-center">
            <v-data-table
              :headers="table.headers"
              :items="table.data"
              class="elevation-1"
              :options="table.options"
              :server-items-length="table.totalItems"
              @update:options="handlerTable"
              :loading="table.isLoad"
              :loading-text="table.loadText"
              :footer-props="table.footer"
            >
            </v-data-table>
          </v-row>
        </v-container>
      </div>
    </v-main>
    <custom-snack-bar></custom-snack-bar>
  </div>
</template>
<script>
import axios from '../../utils/axiosWrapperAutoservicio'
import uris from '../../utils/uris'
import StrategioAppBar from '../../components/header-bar/strategio-app-bar.vue'
import CustomSnackBar from '../../components/snackbars/custom-snack-bar.vue'
import userStorage from '../../storage/userStorage'
import eventBus from '../../utils/eventBus'
export default {
  name: 'show-autoservicio-data',
  components: {
    StrategioAppBar,
    CustomSnackBar
  },
  data () {
    const user = userStorage.getUserInfo()
    return {
      asLogId: Number(this.$route.params.id),
      processID: Number(this.$route.params.processID),
      userType: user.userType,
      isAdmin: user.userType === 'ADMIN',
      table: {
        headers: [
        ],
        totalItems: -1,
        data: [],
        options: {
          // multiSort: true,
          itemsPerPage: 10
        },
        isLoad: true,
        loadText: 'Obteniendo datos...',
        footer: {
          itemsPerPageAllText: 'Todos',
          itemsPerPageText: 'Registro por pagina',
          itemsPerPageOptions: [10, 20, 30, -1]
        }
      },
      btnDownload: {
        isLoad: false
      },
      dataInfo: []
    }
  },
  methods: {
    donwnloadData () {
      this.btnDownload.isLoad = true
      axios.post(uris.URL_AUTOSERVICIO_GET_DATA, {
        processID: this.processID,
        asLogId: this.asLogId,
        excel: 1,
        query: { 'limit': -1 }
      }, {
        responseType: 'blob'
      })
        .then((response) => {
          const filename = response.headers.filename
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          link.remove()
        })
        .catch(() => {
          eventBus.$emit('open-custom-snack-bar', {message: 'No se pudo obtener archivo', itsOk: 'warning'})
        })
        .finally(() => {
          this.btnDownload.isLoad = false
        })
    },
    getData (filter = {}) {
      this.table.isLoad = true
      axios.post(uris.URL_AUTOSERVICIO_GET_DATA, {
        processID: this.processID,
        asLogId: this.asLogId,
        ...filter
      })
        .then((response) => {
          this.handlerHeader(response.data['headers'])
          this.table.totalItems = response.data['total']
          this.table.data = this.handlerData(response.data['data'])
          this.handlerDataInfo(response.data['data_info'])
        })
        .catch((err) => {
          let responseError = err.response ? err.response.data : { error: 'No se pudo obtener datos' }
          eventBus.$emit('open-custom-snack-bar', {message: responseError['error'], itsOk: 'warning'})
        })
        .finally(() => {
          this.table.isLoad = false
        })
    },
    handlerTable: function (option) {
      this.getData({ query: { 'page': option.page, 'limit': option.itemsPerPage } })
    },
    handlerData: function (data) {
      if (!Array.isArray(data)) return []
      const strDate = (str = '') => str ? str.substring(0, 10) : ''
      const formatPrice = price => (price == null ? 0.0 : price).toFixed(2)
      const handlerData = data.map(row => ({...row, Fecha: strDate(row.Fecha), PrecioUnitario: formatPrice(row.PrecioUnitario), PrecioTotalSinIGV: formatPrice(row.PrecioTotalSinIGV)}))
      return handlerData
    },
    handlerDataInfo: function (data) {
      this.dataInfo = Array.isArray(data) ? data : []
    },
    handlerHeader: function (data) {
      if (!Array.isArray(data)) return null
      this.table.headers = data.map(item => ({ text: item, value: item }))
    },
    goBack () {
      this.$router.back()
    },
    formatNum (num) {
      return num != null ? Math.abs(num).toFixed(2) : 0.0
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/routes/autoservicios/show-autoservicio-data.vue